export enum AppDocumentType {
  BILL = 1,
  PURCHASE_ORDER = 2,
  EXPENSE = 4,
  PURCHASE_ORDER_RECEIPT = 3,
  EXPENSE_REPORT = 4,
  BILL_PAYMENT = 5,
  EXPENSE_PAYMENT = 11,
  VENDOR = 6,
  OPPORTUNITY,
  PROPOSAL,
  PROJECT = 12,
  ACCOUNT = 13,
  CREDIT_NOTE = 8,
  CREDIT_CARD = 9,
  BATCH_PAYMENT = 10,
  INTEGRATED_PAYMENTS= 12
}
